import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../../core/routing/services/profile_api/profile.service';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CommonService } from '../../../common/services/common.service';
@Component({
  selector: 'iposcen-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {  
  @Input() public profileDetails;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  profileName: string;
  deleteLaptop: string;
  deletedDesc: string;
  cancel: string;
  deleteProfile: string;
  direction: string;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private activeModal: NgbActiveModal, 
    private profileService: ProfileService,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.deleteLaptop = GlobalConstants.DELETE_LAPTOP;
    this.deletedDesc = GlobalConstants.DELETE_DESCRIPTION;
    this.cancel = GlobalConstants.CANCEL;
    this.deleteProfile = GlobalConstants.DELETE_PROFILE;
    this.profileName = this.profileDetails.profileName;
  }
  close() {
   this.activeModal.close();
  }
  //gtm(Google tag manager)=>it is for now only, when delete profile will work, gtm should change accordingly
  deleteCurrentProfile(){
    this.profileService.removeProfile(this.profileDetails.profileId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(deleteResponse => {
        if(deleteResponse) {
          this.passEntry.emit(deleteResponse.profile.profileId);
        }
      });
    window['dataLayer'].push({
      'delete_current_ipos':true
      });
  }

}
